import throttle from '../base/_throttle.js';
export default class SplitHeader {
	constructor() {
		this.node = document.querySelector('.split-header');
		this.figure = document.querySelector('.split-header__figure');

		if (!this.figure) {
			return;
		}

		let headerheight = this.node.offsetHeight;
		this.figure.style.setProperty('--height', headerheight + 'px');
		window.addEventListener('resize', throttle(this.widthCheck.bind(this), 25));
	}

	widthCheck = () => {
		if (!this.figure) {
			return;
		}
		this.headerheight = this.node.offsetHeight;

	}
}
